import React from "react";
import {FC} from "react";
import {AtLogo} from "../base/Navbar/AtLogo";

interface Props {
  title: string,
  transcripts: {
    content: string,
    title: string
  }[]
}

export const PodcastTranscriptTemplate: FC<Props> = ({ title, transcripts }) => {
  const styles = {
    document: {
      maxWidth: 625
    },
    list: {
      listStyle: 'none',
      margin: 0,
      padding: 0
    },
    header: {
      background: '#00B74F',
      padding: 16
    },
    item: {
      listStyle: 'none',
      marginBottom: 16
    },
    logo: {
      maxWidth: 150
    },
    podcastTitle: {
      color: '#00b74f',
      fontFamily: 'helvetica',
      fontSize: 24,
      lineHeight: 1.2,
      marginBottom: 40,
      textAlign: 'left'
    },
    text: {
      color: '#333',
      fontFamily: 'sans-serif',
      fontSize: 13,
      fontWeight: 300,
      lineHeight: 1.3,
      textAlign: 'justify'
    },
    title: {
      color: '#111',
      fontSize: 16,
      fontWeight: 600,
      marginBottom: 4
    }
  };
  return (
      <div style={styles.document}>
        <header style={styles.header}>
          <img src={'/images/at-logo.png'} alt="at logo" style={styles.logo} />
        </header>
        <h1 style={styles.podcastTitle}>{title}</h1>
        <ul style={styles.list}>
          {transcripts.map((t, i) => (
              <li key={i} style={styles.item}>
                <h4 style={styles.title}>{t.title}</h4>
                <p style={styles.text}>{t.content}</p>
              </li>
          ))}
        </ul>
      </div>
  );
}
